export default {
    Categories:[],
    brands:[],
    product:{},
    products:[],
    meta: {},

}
